import { SERVICE_TYPE_LABELS } from '../../constants/labels';

interface ViewServiceTypeContentProps {
  formattedDescription: string;
  formattedCreatedAt: string;
  formattedUpdatedAt: string;
  formattedUpdatedBy: string;
}

const ViewServiceTypeContent = ({
  formattedDescription,
  formattedCreatedAt,
  formattedUpdatedAt,
  formattedUpdatedBy,
}: ViewServiceTypeContentProps) => {
  return (
    <div className="flex flex-col gap-6 m-[6px]">
      <div className="flex flex-col gap-4 border-[1px] border-[#DCDDE0] rounded-[8px] p-4">
        <p
          className="text-[18px] font-medium text-on-surface-variant"
          aria-label={SERVICE_TYPE_LABELS.SECTION_DETAILS}
          data-testid="view-service-type-title"
        >
          {SERVICE_TYPE_LABELS.SECTION_DETAILS}
        </p>
        <div className="flex flex-col gap-8">
          <div className="flex min-w-0 flex-col gap-2">
            <h2
              className="text-bodySmall font-normal text-on-surface-variant"
              data-testid={SERVICE_TYPE_LABELS.FIELD_DESCRIPTION}
            >
              {SERVICE_TYPE_LABELS.FIELD_DESCRIPTION}
            </h2>
            <p
              className="min-w-0 break-words text-bodyLarge font-normal text-neutral-10 align-middle"
              data-testid={`${SERVICE_TYPE_LABELS.FIELD_DESCRIPTION}-value`}
            >
              {formattedDescription}
            </p>
          </div>
          <div
            className="grid gap-x-16 gap-y-8"
            style={{ gridTemplateColumns: 'minmax(0, 1fr) minmax(0, 1fr)' }}
          >
            <div className="flex min-w-0 flex-col gap-2">
              <h2
                className="text-bodySmall font-normal text-on-surface-variant"
                data-testid={SERVICE_TYPE_LABELS.FIELD_CREATED_AT}
              >
                {SERVICE_TYPE_LABELS.FIELD_CREATED_AT}
              </h2>
              <p
                className="min-w-0 break-words text-bodyLarge font-normal text-neutral-10 align-middle"
                data-testid={`${SERVICE_TYPE_LABELS.FIELD_CREATED_AT}-value`}
              >
                {formattedCreatedAt}
              </p>
            </div>
            <div className="flex min-w-0 flex-col gap-2">
              <h2
                className="text-bodySmall font-normal text-on-surface-variant"
                data-testid={SERVICE_TYPE_LABELS.FIELD_UPDATED_AT}
              >
                {SERVICE_TYPE_LABELS.FIELD_UPDATED_AT}
              </h2>
              <p
                className="min-w-0 break-words text-bodyLarge font-normal text-neutral-10 align-middle"
                data-testid={`${SERVICE_TYPE_LABELS.FIELD_UPDATED_AT}-value`}
              >
                {formattedUpdatedAt}
              </p>
            </div>
            <div className="col-span-2 flex min-w-0 flex-col gap-2">
              <h2
                className="text-bodySmall font-normal text-on-surface-variant"
                data-testid={SERVICE_TYPE_LABELS.FIELD_UPDATED_BY}
              >
                {SERVICE_TYPE_LABELS.FIELD_UPDATED_BY}
              </h2>
              <p
                className="min-w-0 break-words text-bodyLarge font-normal text-neutral-10 align-middle"
                data-testid={`${SERVICE_TYPE_LABELS.FIELD_UPDATED_BY}-value`}
              >
                {formattedUpdatedBy}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewServiceTypeContent;
